module.exports = __webpack_public_path__ + "img/joker-icon.3e9a88c4.svg";